import { FormInputTextComponent } from './form-input-text/form-input-text.component';
import { FormInputCheckboxComponent } from './form-input-checkbox/form-input-checkbox.component';
import { FormInputSelectComponent } from './form-input-select/form-input-select.component';
import { FormInputMultiselectComponent } from './form-input-multiselect/form-input-multiselect.component';
import {FormInputNumberComponent} from '@shared/components/form/form-input-number/form-input-number.component';

export const FormInputs = [
    FormInputTextComponent,
    FormInputCheckboxComponent,
    FormInputSelectComponent,
    FormInputMultiselectComponent,
    FormInputNumberComponent
];
